<template>
  <div>
    <div class="home-top-progress">
      <div class="home-top-progress_text">
        <div class="home-num">
          <big-number v-if="isBigNumber" :number="num"/>
          <span v-else>{{ splitK(num,'int') }}</span>
        </div>
        <div class="home-progress-bottom" v-html="desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { splitK } from "@/utils/index.js"
export default {
  props: ["num", "numDesc", "total", "desc","isBigNumber"],
  components: {},
  data() {
    return {
      splitK:splitK
    };
  },
  methods: {
  },
  created() {},
  watch: {}
};
</script>
<style scoped lang="scss">
.home-top-progress {
  position: relative;
  margin: 0 0.4rem 0 0.4rem;
  min-width:1.9rem;
  .home-top-progress_text {
    text-align: center;
    .home-num {
      font-size: 0.36rem;
      margin-bottom:0.24rem;
    }
    .home-text {
      font-size: 0.14rem;
    }
  }
  .home-progress-bottom {
    font-size: 0.18rem;
    white-space: nowrap;
  }

}
.self-progress {
  ::v-deep svg,
  ::v-deep .el-progress-circle {
    width: 1.2rem !important;
    height: 1.2rem !important;
  }
  ::v-deep path:first-child {
    stroke: rgba(255, 255, 255, 0) !important;
  }
}
</style>
